<template>
    <div>        
        <div id="export" class="row" style="padding: 20px; margin-right: 0">
            <FormRenderer
                v-if="formData"
                v-model="formInputData"
                :class="{'col-md-9': isShowData, 'col-md-12': !isShowData}"
                :form-configuration="formData"
                :readOnly="readOnly"
                :siteID="this.siteID"
                :patNum=this.patNum
                :viewSubmissionMode="viewSubmissionMode"
                :language="submissionLanguage"
            />            
        </div>
    </div>
</template>

<script>
    /**
     * NOTE - This file only exists for development purpose.
     */
    import Vue from 'vue';
    import FormBuilder from "./FormBuilder";
    import FormRenderer from "./FormRenderer";    
    import { mapState, mapActions, mapMutations } from 'vuex';    
    import Multiselect from "vue-multiselect";
    import mixin from "../../../mixin.js";
    import "../css/bootstrap-4.3.1.min.css";
    import "../css/v-form-builder.css";    

    export default {
        name: "ViewSubmissionForPDF",
        props: ['formSubmissionID'],
        mixins: [mixin],
        components: {
            FormBuilder,
            FormRenderer,            
            Multiselect
        },

        mounted() {            
            let script = document.createElement('script');
            script.type = 'application/javascript';
            script.src = 'https://cdnjs.cloudflare.com/ajax/libs/html2pdf.js/0.10.1/html2pdf.bundle.min.js';
            document.head.appendChild(script);
        },

        created() {            
            this.init();
            this.$formEvent.$on("submit", async(value) => {
                //console.dir(this.formInputData);
                if(!this.selectedForm || !this.selectedForm.FormIDForWeb) {                    
                    this.$toast.error('Somethng is not right. Please try refreshing and submitting the form again');
                    return;
                }
                await this._saveFormSubmission();
            })
        },

        data: () => ({
            forms: [],
            selectedForm: [],
            formSubmissionData: [],
            patientNum: null,
            formName: "",
            formData: null,
            isShowDevNote: false,
            isRenderer: false,
            formInputData: null,
            isShowData: true,
            readOnly: false,
            viewSubmissionMode: true,   // whether we are viewing the submitted form so that i can hide certain things like page breaks, signature clear link etc.
            submissionLanguage: 'en',   // language the submission was made in
        }),

        methods: {
            ...mapActions('alert', ['setDismissSuccessCountDown', 'setErrored', 'setMessage']),
            ...mapActions('forms', ['getFormSubmission', 'saveFormPdf']),

            async init() {
                if(!this.formSubmissionID) {                    
                    this.$toast.error('Form Submission ID is required. Please try again');
                    return false;
                } else {
                    let res = await this.getFormSubmission({formSubmissionIDForWeb: this.formSubmissionID});
                    //console.dir(res);                    
                    if(res.data) {
                        this.patientNum = res.data.PatNum;
                        this.formData = Object.assign({}, JSON.parse(res.data.ConfigData), {showSubmit: false});
                        //console.dir(this.formData);
                        this.formSubmissionData = Object.assign({}, JSON.parse(res.data.FormSubmissionData));
                        //console.dir(this.formSubmissionData);
                        // Get the language the submission was made in (default to 'en' for backward compatibility)
                        this.submissionLanguage = res.data.Language || 'en';
                        Vue.nextTick(() => {
                            this.$set(this, 'formInputData', this.formSubmissionData);
                        });
                    }
                    else {
                        console.log(`Something went wrong with getting this form submission: ${res}`);
                    }
                }
            },

            formsCustomLabel({Name, FormIDForWeb}) {
                return `${Name}`;
            },

            viewRenderer() {
                if (!this.isRenderer) {
                    this.setData();
                    this.isRenderer = true;
                    return;
                }

                this.isRenderer = false;
            },

            async doExport() {
                let pdfCategory = this.formData.formConfig.pdfCategory;
                let pdfFileName = this.formData.formConfig.pdfFileName;
                let attachmentCategory = this.formData.formConfig.attachmentCategory;

                if(!pdfFileName || pdfFileName === '') {                    
                    this.$toast.error('PDF File Name missing. Please configure the form correctly');
                    return false;
                }   
                
                if(!pdfCategory || pdfCategory === '') {                    
                    this.$toast.error('PDF Category is missing. Please configure the form correctly');
                    return false;
                }   

                if(!attachmentCategory || attachmentCategory === '') {                    
                    this.$toast.error('Attachment Category is missing. Please configure the form correctly');
                    return false;
                }   

                //console.log('pdfFileName', pdfFileName);

                let e = document.getElementById("export");
                // eslint-disable-next-line
                //var worker = html2pdf();

                
                var opt = {
                    margin: 0.5,

                    image:        {
                        type: 'png',
                        quality: 1
                    },

                    html2canvas:  {
                                    dpi: 300,
                                    letterRendering: true,
                                    scale: 3,
                                    useCORS: true,
                                    logging: false,
                                    backgroundColor: '#ffffff',
                                    removeContainer: true
                    },

                    jsPDF:        { unit: 'in',
                                    format: 'a4', // a0-a10, legal, letter
                                    orientation: 'p'
                    },

                    enableLinks: true
                };                
                
                /*
                // eslint-disable-next-line
                html2pdf().from(e).toPdf().get('pdf').then(function (pdfObj) {
                     // You have access to the jsPDF object and can use it as desired.
                    console.log(pdfObj);
                });
                */

                // eslint-disable-next-line
                //let pdf = await html2pdf().from(e).toPdf().get('pdf');

                // eslint-disable-next-line                
                const blob = await window.html2pdf().set(opt).from(e).outputPdf('blob', 'test.pdf');
                //const blob = await window.html2pdf().from(e).outputPdf('blob', 'test.pdf');               
                let file = new File([blob], 'test.pdf');
                
                // below 4 lines is only for testing making the form..i can comment it out later                                
                var link=document.createElement('a');
                link.href=window.URL.createObjectURL(blob);
                //link.download="saumil-test" + new Date() + ".pdf";
                link.download="form.pdf";
                link.click();
                                
                
                const params = {   
                  siteID: this.siteID,
                  pdfCategory: pdfCategory,     
                  attachmentCategory: attachmentCategory,   
                  name: pdfFileName,
                  patNum: this.patientNum,                  
                  type: 'application/pdf',
                  teamioType: 'FORM_PDF'  // wiki image, form image, etc..
                };

                let payload = {
                    file: file,
                    params: params
                }

                console.log('payload', payload);
                //await this.saveFormPdf(payload);                
            }
        },

        computed: {            
            ...mapState({
                loading: state => state.alert.loading,
                loaded: state => state.alert.loaded,
                errored: state => state.alert.errored,
                alertMessage: state => state.alert.message,                
            })
        }
    }
</script>

<!-- New step!
     Add Multiselect CSS. Can be added as a static asset or inside a component. -->
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
    .control-view {
        margin-top: 5px;
    }

    pre {
        background: #333;
        white-space: pre;
        word-wrap: break-word;
        overflow: auto;
    }

    pre.code {
        margin: 20px 0;
        border-radius: 4px;
        border: 1px solid #292929;
        position: relative;
    }

    pre.code code {
        display: block;
        padding: 15px 16px 14px;
        border-left: 1px solid #555;
        overflow-x: auto;
        font-size: 13px;
        line-height: 19px;
        color: #ddd;
    }

    /*
     * Global CSS overrides for PDF export - removes gray backgrounds from Editor.js wiki controls
     * These styles are NOT scoped so they will apply globally and be captured by html2pdf.js
     */

    /* Wiki control container backgrounds */
    .wiki-patient-view,
    .wiki-builder-preview {
        background-color: #fff !important;
    }

    /* Editor.js main container */
    .abc {
        background-color: transparent !important;
        background: transparent !important;
    }

    /* All Editor.js internal elements */
    .codex-editor {
        background-color: transparent !important;
        background: transparent !important;
    }

    .codex-editor__redactor {
        background-color: transparent !important;
        background: transparent !important;
    }

    .ce-block {
        background-color: transparent !important;
        background: transparent !important;
    }

    .ce-block__content {
        background-color: transparent !important;
        background: transparent !important;
    }

    .ce-toolbar {
        background-color: transparent !important;
        background: transparent !important;
    }

    .ce-inline-toolbar {
        background-color: transparent !important;
        background: transparent !important;
    }

    .ce-conversion-toolbar {
        background-color: transparent !important;
        background: transparent !important;
    }

    .ce-settings {
        background-color: transparent !important;
        background: transparent !important;
    }

    /* Contenteditable divs inside editor */
    .abc div[contenteditable],
    .codex-editor div[contenteditable],
    .ce-block div[contenteditable] {
        background-color: transparent !important;
        background: transparent !important;
    }

    /* Paragraph blocks */
    .ce-paragraph {
        background-color: transparent !important;
        background: transparent !important;
    }

    /* Header blocks */
    .ce-header {
        background-color: transparent !important;
        background: transparent !important;
    }

    /* List blocks */
    .cdx-list {
        background-color: transparent !important;
        background: transparent !important;
    }

    .cdx-list__item {
        background-color: transparent !important;
        background: transparent !important;
    }

    /* Checklist blocks */
    .cdx-checklist {
        background-color: transparent !important;
        background: transparent !important;
    }

    .cdx-checklist__item {
        background-color: transparent !important;
        background: transparent !important;
    }

    /* Table blocks */
    .tc-table {
        background-color: transparent !important;
        background: transparent !important;
    }

    /* Any remaining nested divs */
    .wiki-patient-view div,
    .wiki-builder-preview div {
        background-color: transparent !important;
    }

    /*
     * Text color overrides for PDF readability
     * Ensures all text is black/dark for clear PDF output
     */
    .wiki-patient-view,
    .wiki-builder-preview,
    .wiki-patient-view *,
    .wiki-builder-preview * {
        color: #000 !important;
    }

    /* Ensure Editor.js content text is black */
    .abc,
    .abc *,
    .codex-editor,
    .codex-editor *,
    .ce-block,
    .ce-block *,
    .ce-block__content,
    .ce-block__content *,
    .ce-paragraph,
    .ce-paragraph *,
    .ce-header,
    .ce-header *,
    .cdx-list,
    .cdx-list *,
    .cdx-list__item,
    .cdx-list__item *,
    .cdx-checklist,
    .cdx-checklist *,
    .cdx-checklist__item,
    .cdx-checklist__item *,
    .tc-table,
    .tc-table * {
        color: #000 !important;
    }

    /* Contenteditable divs text color */
    .abc div[contenteditable],
    .abc div[contenteditable] *,
    .codex-editor div[contenteditable],
    .codex-editor div[contenteditable] *,
    .ce-block div[contenteditable],
    .ce-block div[contenteditable] * {
        color: #000 !important;
    }

    /*
     * Form Renderer CSS overrides for PDF export
     * Ensures all form text is clearly visible and not faded in PDF output
     */

    /* Main form renderer container */
    .vue-form-renderer,
    .vue-form-renderer * {
        color: #000 !important;
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
    }

    /* Form labels - ensure bold black text */
    .vue-form-renderer label,
    .vue-form-renderer .control-label-container,
    .vue-form-renderer .control-label-container label,
    .vue-form-renderer .control-label-container small {
        color: #000 !important;
        opacity: 1 !important;
        font-weight: 600 !important;
    }

    /* Form control views */
    .vue-form-renderer .control-view,
    .vue-form-renderer .control-view-wrapper,
    .vue-form-renderer .control-view p,
    .vue-form-renderer .control-view span,
    .vue-form-renderer .control-view div {
        color: #000 !important;
        opacity: 1 !important;
    }

    /* Form inputs and their values */
    .vue-form-renderer input,
    .vue-form-renderer textarea,
    .vue-form-renderer select,
    .vue-form-renderer .form-control {
        color: #000 !important;
        opacity: 1 !important;
        border-color: #333 !important;
    }

    /* Checkbox and radio labels */
    .vue-form-renderer .radio-checkbox label,
    .vue-form-renderer .checkbox label,
    .vue-form-renderer .radio label,
    .vue-form-renderer .custom-control-label,
    .vue-form-renderer .form-check-label {
        color: #000 !important;
        opacity: 1 !important;
    }

    /* Form headlines and headings */
    .vue-form-renderer h1,
    .vue-form-renderer h2,
    .vue-form-renderer h3,
    .vue-form-renderer h4,
    .vue-form-renderer h5,
    .vue-form-renderer h6,
    .vue-form-renderer .form-headline-container h1,
    .vue-form-renderer .form-headline-container p {
        color: #000 !important;
        opacity: 1 !important;
    }

    /* Section containers */
    .vue-form-renderer .section-container,
    .vue-form-renderer .normal-section,
    .vue-form-renderer .toggleable-section {
        background-color: #fff !important;
    }

    /* Table elements in forms */
    .vue-form-renderer table,
    .vue-form-renderer th,
    .vue-form-renderer td {
        color: #000 !important;
        border-color: #333 !important;
    }

    /* Remove any text shadows that might cause fading */
    .vue-form-renderer * {
        text-shadow: none !important;
    }

    /* Ensure proper font rendering for PDF */
    .vue-form-renderer {
        -webkit-font-smoothing: antialiased !important;
        -moz-osx-font-smoothing: grayscale !important;
    }

    /* Fix for disabled/readonly fields that may appear faded */
    .vue-form-renderer input:disabled,
    .vue-form-renderer textarea:disabled,
    .vue-form-renderer select:disabled,
    .vue-form-renderer input[readonly],
    .vue-form-renderer textarea[readonly],
    .vue-form-renderer .form-control:disabled,
    .vue-form-renderer .form-control[readonly] {
        color: #000 !important;
        opacity: 1 !important;
        -webkit-text-fill-color: #000 !important;
        background-color: #fff !important;
    }

    /* Placeholder text - make it black for PDF since values are displayed */
    .vue-form-renderer ::placeholder {
        color: #000 !important;
        opacity: 1 !important;
    }

    /* Bootstrap form controls overrides */
    .vue-form-renderer .form-control,
    .vue-form-renderer .custom-select {
        color: #000 !important;
        background-color: #fff !important;
    }

    /* Signature and special controls */
    .vue-form-renderer .signature-pad,
    .vue-form-renderer canvas {
        opacity: 1 !important;
    }

    /* Signatures: use the full row width in the exported PDF so they're large and
       legible rather than confined to a narrow form column (e.g. col-md-4). Only
       affects wrappers that actually contain a signature. Paired with the taller
       .signature-view-mode box; the fit helper keeps the whole signature in view. */
    #export .control-view-wrapper:has(.signature-container) {
        flex: 0 0 100% !important;
        max-width: 100% !important;
        width: 100% !important;
    }

    /* Any spans or divs with inline styles */
    .vue-form-renderer span[style],
    .vue-form-renderer div[style],
    .vue-form-renderer p[style] {
        color: #000 !important;
    }

    /* Export container */
    #export,
    #export * {
        color: #000 !important;
    }

    #export label,
    #export p,
    #export span,
    #export div {
        color: #000 !important;
        opacity: 1 !important;
    }
</style>
